module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_vm._v("\n    สวัสดี, ยินดีที่ได้รู้จัก  🎉\n  ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n    Biomatic จะโฟกัสที่ไปที่การใช้ Atomic Class เพื่อสร้างชุดของ Style\n    ที่คุณต้องการเป็นหลัก หรือใช้งานควบคู่ไปกับ Component Class อื่นๆ เพื่อสร้างผลลัพธ์ที่คุณต้องการ\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_vm._v("\n    Biomatic เหมาะสำหรับใคร  🤔\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-32px _fs-5"
  }, [_vm._v("\n    Biomatic เหมาะสำหรับผู้ที่มีความเข้าใจในพื้นฐานเรื่อง CSS หรือ\n    ผู้ที่สนใจเรื่อง Atomic CSS Methodologies เนื่องจาก Biomatic โฟกัสที่ Atomic CSS เป็นหลัก\n    ถ้าคุณมีความเข้าใจในพื้นฐานเรื่อง CSS คุณจะมีความคล่องตัวในการทำงานสูงมาก 🔥\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n    นอกจากนี้ Biomatic ได้จัดเตรียม Components พื้นฐานที่จำเป็นไว้ให้คุณใช้งาน\n    รวมไปถึงเรื่องของการจัดการ Layout ที่ใช้งานได้ง่าย และไม่ซับซ้อน\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_vm._v("\n    ส่วนประกอบของ Biomatic  😍\n  ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-32px _fs-5"
  }, [_vm._v("\n    ปัจจุบัน Biomatic ทำการ Build รวม Class ทั้งหมดไว้เป็น Minified Complied CSS เพียงไฟล์เดียว\n    เพื่อความสะดวกในการติดตั้งและใช้งาน ตัวเลือกอื่นๆ จะถูกเพิ่มเติมในภายหลัง 🙇\n  ")]), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-fe"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'Installation'
      }
    }
  }, [_vm._v("\n        การติดตั้ง   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-6"
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-64px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#getting-start"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" เกี่ยวกับ Biomatic\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-32px _fs-5"
  }, [_c('strong', [_vm._v("Biomatic")]), _vm._v(" เป็น CSS Framework ที่สร้างขึ้นมาโดยคำนึงถึงความยืดหยุ่น\n    และความสะดวกในการใช้งานเป็นหลัก\n    เหมาะสำหรับผู้ที่ต้องการจัดการ User Interface อย่างละเอียด รวดเร็ว และสนุก!\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Biomatic แบ่งออกได้เป็น 4 ส่วน")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_vm._v("\n        • "), _c('strong', [_vm._v("Atomic Class")]), _vm._v(" – ใช้กำหนด Style ให้ HTML Element และใช้ร่วมกับ Class อื่นๆ"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_vm._v("\n        • "), _c('strong', [_vm._v("Component Class")]), _vm._v(" – ใช้แสดงผล Components พื้นฐานต่างๆ เช่น Button, Breadcrumb หรือ Card"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_vm._v("\n        • "), _c('strong', [_vm._v("Layout Class")]), _vm._v(" –\n    ใช้จัดการ Responsive Grid, และ Container ต่างๆ\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        • "), _c('strong', [_vm._v("Utility Class")]), _vm._v(" – ใช้เพิ่มพฤติกรรมที่มีความซับซ้อนให้ HTML Element เช่น Animation\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a02ecf70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/document-pages/Introduction.vue
// module id = 142
// module chunks = 0